import { Card, CardContent, CardHeader } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { useWizardWithData } from '../../../../../../../../../core/hooks/WizardWithData';
import { useAodFactory } from '../../../custom/AodFactory';
import { AodRuleWizardCompletedValues } from '../../../types';
import { AodBaseReview } from './AodBaseReview';

export function AodRuleStep_ReviewStep() {
  const { data } = useWizardWithData<AodRuleWizardCompletedValues>();
  const {
    views: { ReportConfig, ExportOptions, ExportConditions },
    valuesToApi,
  } = useAodFactory(data.basic.reportType);
  const apiValues = valuesToApi(data);

  return (
    <AodBaseReview>
      <Card sx={{ mb: 3 }}>
        <CardHeader
          title={
            <FormattedMessage
              id="audit.aod.review.reportConfigTitle"
              defaultMessage="Configuración del Reporte"
            />
          }
        />
        <CardContent>
          <ReportConfig reportConfig={apiValues.reportConfig} />
        </CardContent>
      </Card>

      {ExportOptions && (
        <Card sx={{ mb: 3 }}>
          <CardHeader
            title={
              <FormattedMessage
                id="audit.aod.review.evidenceExportTitle"
                defaultMessage="Export de evidencia"
              />
            }
          />
          <CardContent>
            <ExportOptions exportOptions={apiValues.exportOptions} />
          </CardContent>
        </Card>
      )}

      {ExportConditions && (
        <Card sx={{ mb: 3 }}>
          <CardHeader
            title={
              <FormattedMessage
                id="audit.aod.review.exportConditionsTitle"
                defaultMessage="Condiciones de Export"
              />
            }
          />
          <CardContent>
            <ExportConditions exportConditions={apiValues.exportConditions} />
          </CardContent>
        </Card>
      )}
    </AodBaseReview>
  );
}
